import React from 'react';

/**
 * Reviews-styled, compact Company Values table.
 * Props unchanged:
 *  - items, total, onAdd, onEdit, onDelete, onValidate, validating, readOnly
 */
export default function CompanyValuesList({
                                              items,
                                              total,
                                              onAdd,
                                              onEdit,
                                              onDelete,
                                              onValidate,
                                              validating = false,
                                              readOnly = true,
                                          }) {
    const showActions = !readOnly && (onEdit || onDelete);
    const rows = Array.isArray(items) ? items : [];

    return (
        <div className="card mt-4">
            <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="mb-0">Company Values</h5>
                <div className="d-flex align-items-center gap-2">
          <span className="badge bg-secondary">
            Total: {Number(total || 0).toFixed(2)} / 10.00
          </span>
                    {!readOnly && onValidate && (
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={onValidate}
                            disabled={validating}
                        >
                            {validating ? 'Validating…' : 'Validate (must = 10.00)'}
                        </button>
                    )}
                    {!readOnly && onAdd && (
                        <button className="btn btn-primary btn-sm" onClick={onAdd}>
                            + Add Value
                        </button>
                    )}
                </div>
            </div>

            <div className="card-body reviews-table">
                {/* horizontal scroll to avoid layout overflow, like Reviews pages */}
                <div className="scroll-x">
                    <table
                        className="table table-sm table-bordered align-middle mb-0 reviews-table"
                        style={{ minWidth: 900 }} // keep a wide canvas like Reviews tables
                    >
                        <thead className="table-light">
                        <tr className='rt-head-top'>
                            <th style={{ width: 90 }}>#</th>
                            <th>Company Value</th>
                            <th style={{ minWidth: 420 }}>Description</th>
                            <th style={{ width: 120 }} className="text-end">
                                Weight
                            </th>
                            {showActions && (
                                <th style={{ width: 160 }} className="text-end">
                                    Actions
                                </th>
                            )}
                        </tr>
                        </thead>
                        <tbody>
                        {rows.length === 0 && (
                            <tr>
                                <td
                                    colSpan={showActions ? 5 : 4}
                                    className="text-center text-muted py-3"
                                >
                                    No company values yet.
                                </td>
                            </tr>
                        )}

                        {rows.map((v, idx) => (
                            <tr key={v.id}>
                                {/* Counter column styled like Reviews pages (e.g., CV 01) */}
                                <td className="text-nowrap">
                                    {`CV ${String(idx + 1).padStart(2, '0')}`}
                                </td>

                                {/* Name column (wide) */}
                                <td className="fw-semibold">{v.name}</td>

                                {/* Description (let it wrap; table scroll handles width) */}
                                <td className="text-break">
                                    {v.description?.trim() ? v.description : '—'}
                                </td>

                                {/* Weight (read-only, right-aligned) */}
                                <td className="text-end">{Number(v.weight).toFixed(2)}</td>

                                {/* Optional Actions */}
                                {showActions && (
                                    <td className="text-end">
                                        <div className="btn-group btn-group-sm">
                                            {onEdit && (
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => onEdit(v)}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                            {onDelete && (
                                                <button
                                                    className="btn btn-outline-danger"
                                                    onClick={() => onDelete(v)}
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}